import { Table } from "antd";
import React from "react";

import "./style/index.css";

const DataTable = ({
  columns,
  pagination,
  loading,
  data,
  handleChange,
  onRowClick,
  handleTableValuesChange,
  scroll,
  type,
  getSelectedRows,
  rowClassName,
  handleRowSelection,
  handleSelection,
  selection,
}) => {
  const handleTableChange = (pagination, filters, sorter) => {
    handleTableValuesChange(pagination, filters, sorter);

    // handleTableValuesChange(pagination, filters.status, sorter);
    // handleChange(filters.status);
  };

  const onSelect = (record, selected, selectedRows, nativeEvent) => {
    if (type) {
      handleSelection(selected, selectedRows);
    }
    // handleRowSelection(selected,)
    // getSelectedRows(selectedRows);
  };
  const onSelectAll = (selected, selectedRows, changeRows) => {
    if (type) {
      handleSelection(selected, selectedRows);
    }

    // getSelectedRows(selectedRows);
  };

  return (
    <Table
      rowClassName={rowClassName}
      columns={columns}
      dataSource={data}
      rowKey={(record) => record.id}
      loading={loading}
      bordered={true}
      rowSelection={
        selection
          ? {
              checkStrictly: true,
              hideSelectAll: false,
              // preserveSelectedRowKeys: false,
              onSelect: onSelect,
              onSelectAll: onSelectAll,
            }
          : false
      }
      onRow={(record, rowIndex) => {
        return {
          onClick: (event) => {
            if (event.target.tagName === "TD") {
              onRowClick(record);
            }
          },
        };
      }}
      pagination={{
        defaultPageSize: 10,
        // pageSize: 10,
        current: pagination?.currentPage + 1,
        total: pagination?.count,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "30"],
        position: ["bottomRight"],
      }}
      onChange={handleTableChange}
      scroll={scroll}
    />
  );
};

export default DataTable;
